export default __webpack_public_path__ + "static/media/cosmetics.5c0e9e19.png";